module.exports = __webpack_public_path__ + "img/gsb.2bc74608.svg";